import React, { useState } from 'react';
import SliderWrapper from 'jd-library/SliderWrapper';
import { connect } from 'react-redux';
import styles from './Styles/upload-prompt.scss'
import ExportHistoryFiles from './ExportHistoryFiles';
import { openHelpUrl } from '../../../utills.js';
import BulkExportPrompt from './BulkExportPrompt';

const ExportHistorySlider = props => {
  const [currentStep, setcurrentStep] = useState(() => 1);
  const leftIcons = [
    {
      className: 'icon-HDRback',
      onClick: () => {
        props.onHidden();
        window.history.back();
      }
    }
  ];
  const rightIcons = [
    {
      className: 'icon-HDRhelp',
      onClick: () => {
          openHelpUrl('Products-View-Export-Products', props.isMobile ? true : false);
      }
    },
    {
      className: 'icon-glHistory icon-piHistory' + ' ' + styles['bigIcon'],
      onClick: () => {
        setcurrentStep(() => 2)
      }
    }
  ]

  return (
    <SliderWrapper
      header={{
        heading: 'Export Products',
        leftIcons,
        rightIcons
      }}
    >
      {/* <BulkUploadPrompt /> */}
      {currentStep === 1 ?
        <BulkExportPrompt supplierId={props.supplierId} setCurrentStep={() => setcurrentStep(() => 2)} /> :
        <ExportHistoryFiles onHidden={props.onHidden} setCurrentStep={() => setcurrentStep(() => 1)} />
      }
    </SliderWrapper>
  )
};

const mapStateToProps = state => {
  return {
    supplierId: state.session.supplierId,
    isMobile: state.library.deviceData.isMobile,
  }
}

export default connect(mapStateToProps)(ExportHistorySlider);